module.exports = __webpack_public_path__ + "img/36_19.463d1324.png";